import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { UnifiedVmLauncherService, VmLaunchModalState } from '../../../services/unified-vm-launcher.service';

@Component({
  selector: 'app-vm-launch-modal',
  templateUrl: './vm-launch-modal.component.html',
  styleUrls: ['./vm-launch-modal.component.css']
})
export class VmLaunchModalComponent implements OnInit, OnDestroy {
  state: VmLaunchModalState = { phase: 'idle' };
  private sub!: Subscription;

  constructor(private launcher: UnifiedVmLauncherService) {}

  ngOnInit(): void {
    this.sub = this.launcher.modalState$.subscribe(s => this.state = s);
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  connect(): void {
    // prepareLaunch now navigates immediately — no 2-phase execute step needed.
  }

  dismiss(): void {
    this.launcher.dismissModal();
  }

  retry(): void {
    // prepareLaunch no longer uses a retry-from-modal flow.
  }

  onOverlayClick(event: MouseEvent): void {
    if (this.state.phase !== 'fetching') {
      this.dismiss();
    }
  }
}
